import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  verifyHeaderUpc: {
    description: 'scan.productCodeInput.upcPlaceholder',
    defaultMessage: 'Scan or enter a UPC to continue',
    id: 'Pn+ZyI',
  },
  verifyHeaderSku: {
    description: 'scan.productCodeInput.skuPlaceholder',
    defaultMessage: 'Scan or enter a SKU to continue',
    id: 'TzQs8N',
  },
  verifyHeaderBoth: {
    description: 'scan.productCodeInput.bothPlaceholder',
    defaultMessage: 'Scan or enter a UPC/SKU to continue',
    id: 'fU4xKt',
  },
  submitScan: {
    description: 'scan.productCodeInput.submitScanButtonLabel',
    defaultMessage: 'Submit Scan',
    id: 'IDi2NP',
  },
});
